var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0028 4.76712C12.5551 4.76712 13.0028 5.21484 13.0028 5.76712L13.0028 15.8156L17.5248 11.2936C17.9154 10.9031 18.5485 10.9031 18.9391 11.2936C19.3296 11.6841 19.3296 12.3173 18.9391 12.7078L12.755 18.8919C12.5717 19.1009 12.3027 19.2329 12.0028 19.2329C12.0002 19.2329 11.9976 19.2329 11.9951 19.2328C11.7407 19.2317 11.4867 19.134 11.2927 18.94L5.0605 12.7078C4.66998 12.3173 4.66998 11.6841 5.0605 11.2936C5.45102 10.9031 6.08419 10.9031 6.47471 11.2936L11.0028 15.8217L11.0028 5.76712C11.0028 5.21484 11.4505 4.76712 12.0028 4.76712Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ArrowDown.4aafa19771ecfb77f028828c49d2802d.svg";